export const SidebarIdCsmApp = 'CSM_APP' as const;
